import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import accountIcon from '@iconify/icons-mdi/account';
import profileIcon from '@iconify/icons-mdi/account-circle-outline';
import usersIcon from '@iconify/icons-mdi/account-group';
import driverIcon from '@iconify/icons-mdi/account-hard-hat';
import reportIcon from '@iconify/icons-mdi/chart-areaspline';
import interventionIcon from '@iconify/icons-mdi/clock-check';
import trackersIcon from '@iconify/icons-mdi/crosshairs-gps';
import fieldIcon from '@iconify/icons-mdi/focus-field';
import fuelIcon from '@iconify/icons-mdi/gas-station';
import transportIcon from '@iconify/icons-mdi/go-kart-track';
import historyIcon from '@iconify/icons-mdi/history';
import manageIcon from '@iconify/icons-mdi/home-city';
import tagsIcon from '@iconify/icons-mdi/id-card';
import logoutIcon from '@iconify/icons-mdi/logout';
import iconMap from '@iconify/icons-mdi/map';
import tankIcon from '@iconify/icons-mdi/propane-tank-outline';
import operationsTypes from '@iconify/icons-mdi/slope-downhill';
import supportIcon from '@iconify/icons-mdi/support';
import tractorIcon from '@iconify/icons-mdi/tractor';
import trailerIcon from '@iconify/icons-mdi/truck-trailer';
import tractorsGridIcon from '@iconify/icons-mdi/view-list-outline';
import settingsIcon from '@iconify/icons-mdi/cog';
import { AuthService, User } from 'shared';
import { LayoutService } from '../home/layout.service';
import { UserService } from '../services/user.service';
import { CookieService } from '../services/cookie.service';
import { ReconstructedInterventionService } from '../stores/reconstructed-intervention.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from 'shared';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  animations: [
    trigger('headerIn', [
      state('void', style({
        transform: 'translateY(-100%)'
      })),
      transition('void => *', animate(350))
    ])
  ]
})

export class ToolbarComponent implements OnInit, OnDestroy {

  pendingInterventionsCount = 0;
  private countUpdateInterval: any;

  constructor(
    public user: User,
    private authService: AuthService,
    private layoutService: LayoutService,
    private userService: UserService,
    private cookieService: CookieService,
    private reconstructedInterventionService: ReconstructedInterventionService,
    private http: HttpClient,
    private config: ConfigService,
  ) {
  }
  manageIcon = manageIcon;
  tractorIcon = tractorIcon;
  profileIcon = profileIcon;
  reportIcon = reportIcon;
  interventionIcon = interventionIcon;
  usersIcon = usersIcon;
  fieldIcon = fieldIcon;
  menus = [];

  mapMenuItem = {
    icon: `<svg>${iconMap.body}</svg>`,
    text: 'Carte',
    hint: 'La Carte',
    elementAttr: { class: 'header-menu-button' },
    onClick: () => {
      this.layoutService.focus('map-content');
    }
  };

  tractorsMenuItem = {
    icon: `<svg>${tractorIcon.body}</svg>`,
    text: 'Tracteurs',
    hint: 'Tracteurs',
    elementAttr: { class: 'header-menu-button' },
    visible: this.user.can('list tractors'),
    items: [
      {
        icon: `<svg>${tractorsGridIcon.body}</svg>`,
        text: 'Liste des Tracteurs',
        hint: 'La Liste des Tracteurs',
        elementAttr: { class: 'header-menu-button' },
        visible: this.user.can('list tractors'),
        onClick: async () => {
          return await this.layoutService.openTab({
            id: 'tractors-grid',
            type: 'component',
            title: 'Tracteurs',
            componentName: 'tractors-grid',
            componentState: {}
          });
        }
      },
      {
        icon: `<svg>${historyIcon.body}</svg>`,
        text: 'Historique des Trajets',
        hint: 'Historique des Trajets',
        elementAttr: { class: 'header-menu-button' },
        visible: this.user.can('list tractors'),
        onClick: async () => {
          return await this.layoutService.openTab({
            id: 'tractors-history',
            type: 'component',
            title: 'Historique',
            componentName: 'tractors-history',
            componentState: {}
          });
        }
      },
      {
        icon: `<svg>${fuelIcon.body}</svg>`,
        text: 'Consommation Carburant',
        hint: 'Consommation Carburant',
        elementAttr: { class: 'header-menu-button' },
        visible: this.user.can('list tractors'),
        onClick: async () => {
          return await this.layoutService.openTab({
            id: 'flow-meter-report-page',
            type: 'component',
            title: 'Consommation Carburant',
            componentName: 'flow-meter-report-page',
            componentState: {}
          });
        }
      },
    ]
  };

  fieldsEditorMenuItem = {
    icon: 'ld-plot-plan',
    text: 'Plan Parcellaires',
    hint: 'Plan Parcellaires',
    elementAttr: { class: 'header-menu-button' },
    visible: this.user.can(
      'list fields',
      'list crops'),
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'field-editor',
        type: 'component',
        title: 'Plan Parcellaires',
        componentName: 'field-editor',
        componentState: {}
      });
    }
  };

  fieldsCropEditorMenuItem = {
    icon: 'ld-crop',
    text: 'Parcelles Culturales',
    hint: 'Parcelles Culturales',
    elementAttr: { class: 'header-menu-button' },
    visible: this.user.can(
      'list fields',
      'list crops'),
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'fields-crops-grid',
        type: 'component',
        title: 'Parcelles Culturales',
        componentName: 'fields-crops-grid',
        componentState: {}
      });
    }
  };

  fieldsListMenuItem = {
    icon: 'ld-list',
    text: 'Parcelles',
    hint: 'La Liste des Parcelles',
    elementAttr: { class: 'header-menu-button' },
    visible: this.user.can('list fields'),
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'fields-grid',
        type: 'component',
        title: 'Parcelles',
        componentName: 'fields-grid',
        componentState: {}
      });
    }
  };

  cropsMenuItem = {
    icon: 'ld-crop',
    text: 'Cultures',
    hint: 'La Liste des Cutltures',
    elementAttr: { class: 'header-menu-button' },
    visible: this.user.can('list crops'),
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'crops-grid',
        type: 'component',
        title: 'Cultures',
        componentName: 'crops-grid',
        componentState: {}
      });
    }
  };

  fieldsMenuItem = [this.fieldsListMenuItem, this.fieldsCropEditorMenuItem, this.fieldsEditorMenuItem];


  trailerInterventionsMenuItem = {
    icon: `<svg>${fieldIcon.body}</svg>`,
    text: 'Interventions Parcelles',
    hint: 'La Liste des Interventions sur les Parcelles',
    elementAttr: { class: 'header-menu-button' },
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'trailer-interventions-grid',
        type: 'component',
        title: 'Interventions Parcelles',
        componentName: 'trailer-interventions-grid',
        componentState: {}
      });
    }
  };

  transportInterventionsMenuItem = {
    icon: `<svg>${transportIcon.body}</svg>`,
    text: 'Interventions Transport',
    hint: 'La Liste des Interventions de Transport',
    elementAttr: { class: 'header-menu-button' },
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'transport-interventions-page',
        type: 'component',
        title: 'Interventions Transport',
        componentName: 'transport-interventions-page',
        componentState: {}
      });
    }
  };

  interventionsMenuItem = [this.trailerInterventionsMenuItem, this.transportInterventionsMenuItem];

  reportsMenuItem = {
    icon: `<svg>${reportIcon.body}</svg>`,
    text: 'Rapports',
    hint: 'Les Rapports',
    elementAttr: { class: 'header-menu-button' },
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'reports-grid',
        type: 'component',
        title: 'Rapports',
        componentName: 'reports-grid',
        componentState: {}
      });
    }
  };

  trackersMenuItem = {
    text: 'Boitiers GPS',
    icon: `<svg>${trackersIcon.body}</svg>`,
    hint: 'La Liste des Traceurs',
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'trackers-grid',
        type: 'component',
        title: 'Boitiers GPS',
        componentName: 'trackers-grid',
        componentState: {}
      });
    },
    visible: this.user.can('list trackers'),
  };

  trailerMenuItem = {
    text: 'Machines & Outils',
    icon: `<svg>${trailerIcon.body}</svg>`,
    hint: 'La Liste des Outils',
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'trailers-grid',
        type: 'component',
        title: 'Machines & Outils',
        componentName: 'trailers-grid',
        componentState: {}
      });
    },
    visible: this.user.can('list trailers'),
  };

  trailerOperationMenuItem = {
    text: 'Opérations Agricoles',
    icon: `<svg>${operationsTypes.body}</svg>`,
    hint: 'La Liste des Opérations Agricoles',
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'trailer-operation-types-grid',
        type: 'component',
        title: 'Opérations Agricoles',
        componentName: 'trailer-operation-types-grid',
        componentState: {}
      });
    },
    visible: this.user.can('list trailer operation types'),
  };

  tagsMenuItem = {
    text: 'Les Cartes',
    icon: `<svg>${tagsIcon.body}</svg>`,
    hint: 'La Liste des Cartes d\'identification,',
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'tags-grid',
        type: 'component',
        title: 'Les Cartes',
        componentName: 'tags-grid',
        componentState: {}
      });
    },
    visible: this.user.can('list tags'),
  };

  tanksMenuItem = {
    text: 'Les Citernes',
    icon: `<svg>${tankIcon.body}</svg>`,
    hint: 'La Liste des Citernes,',
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'tanks-grid',
        type: 'component',
        title: 'Les Citernes',
        componentName: 'tanks-grid',
        componentState: {}
      });
    },
    visible: this.user.can('list tags'),
  };

  equipmentsMenuList = [
    this.tractorsMenuItem,
    this.trailerMenuItem,
    this.trailerOperationMenuItem,
    this.trackersMenuItem,
    this.tagsMenuItem,
    this.tanksMenuItem];

  usersMenuItem = {
    text: 'Utilisateurs',
    icon: `<svg>${usersIcon.body}</svg>`,
    hint: 'La Liste des Utilisateurs',
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'users-grid',
        type: 'component',
        title: 'Utilisateurs',
        componentName: 'users-grid',
        componentState: {}
      });
    },
    visible: this.user.can('list users'),
  };

  driversMenuItem = {
    text: 'Opérateurs',
    icon: `<svg>${driverIcon.body}</svg>`,
    hint: 'La Liste des Opérateurs',
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'drivers-grid',
        type: 'component',
        title: 'Opérateurs',
        componentName: 'drivers-grid',
        componentState: {}
      });
    },
    visible: this.user.can('list drivers'),
  };

  parametersMenuItem = {
    text: 'Paramètres',
    icon: `<svg>${settingsIcon.body}</svg>`,
    hint: 'Paramètres',
    elementAttr: { class: 'header-menu-button' },
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'parameters',
        type: 'component',
        title: 'Paramètres',
        componentName: 'parameters',
        componentState: {}
      });
    }
  };

  usersMenuList = [this.usersMenuItem, this.driversMenuItem, this.cropsMenuItem, this.parametersMenuItem];

  accountMenuItem = {
    id: 'account',
    icon: `<svg>${accountIcon.body}</svg>`,
    text: 'Mon Compte',
    onClick: async () => {
      return this.layoutService.openTab({
        id: 'profile-edit',
        type: 'component',
        title: 'Mon Compte',
        componentName: 'profile-edit',
        componentState: {}
      });
    }
  };

  supportMenuItem = {
    id: 'support',
    icon: `<svg>${supportIcon.body}</svg>`,
    text: 'Mes demandes d\'assistance',
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'support-ticket-grid',
        type: 'component',
        title: 'Mes demandes d\'assistance',
        componentName: 'tickets-grid',
        componentState: {}
      });
    }
  };

  logoutMenuItem = {
    id: 'logout',
    icon: `<svg>${logoutIcon.body}</svg>`,
    text: 'Se Déconnecter',
    onClick: async () => {
      return this.authService.logout();
    }
  };

  profileMenuList = [this.accountMenuItem, this.supportMenuItem, this.logoutMenuItem];

  fieldsGeneralReportMenuItem = {
    icon: `<svg>${fieldIcon.body}</svg>`,
    text: 'Rapport Parcelle',
    hint: 'Rapport Parcelle',
    elementAttr: { class: 'header-menu-button' },
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'fields-general-report',
        type: 'component',
        title: 'Rapport Parcelle',
        componentName: 'fields-general-report',
        componentState: {}
      });
    }
  };

  reportsGeneralMenuItem = {
    icon: `<svg>${reportIcon.body}</svg>`,
    text: 'Rapport Général',
    hint: 'Rapport Général',
    elementAttr: { class: 'header-menu-button' },
    onClick: async () => {
      return await this.layoutService.openTab({
        id: 'reports-grid',
        type: 'component',
        title: 'Rapport Général',
        componentName: 'reports-grid',
        componentState: {}
      });
    }
  };

  reportsMenuList = [this.reportsGeneralMenuItem];

  sessionUpdate = setInterval(() => {
    const sessionID = parseInt(this.cookieService.getCookie('sessionID'));

    if (Number.isNaN(sessionID)) {
      this.userService.startSession(this.user.id).subscribe((sessionID) => {
        const d = new Date();

        this.cookieService.setCookie("sessionID", sessionID.toString(), this.timeDiff(d.getHours()))
      });
    } else {
      this.userService.updateSession(sessionID).subscribe();
    }
  }, 5 * 60 * 1000);

  ngOnInit(): void {
    if (this.cookieService.getCookie('sessionID') == null) {
      this.userService.startSession(this.user.id).subscribe((sessionID) => {
        const d = new Date();

        this.cookieService.setCookie("sessionID", sessionID.toString(), this.timeDiff(d.getHours()))
      });
    }

    // Load pending interventions count if user has permission
    if (this.user.can('list reconstructed_interventions')) {
      this.loadPendingCount();
      // Update count every 30 seconds
      this.countUpdateInterval = setInterval(() => {
        this.loadPendingCount();
      }, 30000);
    }
  }

  loadPendingCount(): void {
    if (!this.user.can('list reconstructed_interventions')) {
      return;
    }

    // Use HTTP client directly to get count with status filter
    const params = new HttpParams()
      .set('status', 'pending_validation')
      .set('skip', '0')
      .set('take', '1'); // We only need the total count

    this.http.get<any>(this.config.apiVerUrl('/app/reconstructed-interventions'), { params })
      .subscribe({
        next: (response) => {
          this.pendingInterventionsCount = response.total || response.totalCount || 0;
        },
        error: (err) => {
          console.error('Error loading pending interventions count:', err);
          this.pendingInterventionsCount = 0;
        }
      });
  }

  @HostListener('window:beforeunload')
  async ngOnDestroy() {
    const sessionID = parseInt(this.cookieService.getCookie('sessionID'));

    if (!Number.isNaN(sessionID)) {
      this.userService.updateSession(sessionID).subscribe(() => {
        this.cookieService.deleteCookie('sessionID');
      });
    }

    clearTimeout(this.sessionUpdate);
    if (this.countUpdateInterval) {
      clearInterval(this.countUpdateInterval);
    }
  }

  hideOthers(e: any) {
    this.menus.forEach(cm => {
      if (cm !== e.component) {
        cm.hide();
      }
    });
  }

  // function to calculate time difference
  timeDiff(time: number): number {
    const inputTime = new Date('2000-01-01T' + time + ':00');
    const midnight = new Date('2000-01-01T00:00:00');
    const diff = inputTime.getTime() - midnight.getTime();
    const days = diff / (1000 * 60 * 60 * 24);

    return parseFloat(days.toFixed(2));
  }
}
